import type { PublicUser } from "./types";

const STORAGE_KEY = "foxygarden.session";

export interface Session {
  token: string;
  expiresAt: string;
  user: PublicUser;
}


/**
 * Com "lembrar de mim" a sessao fica no localStorage e sobrevive ao fechar o
 * navegador; sem, fica no sessionStorage e some junto com a aba.
 */
function storages(): Storage[] {
  return [localStorage, sessionStorage];
}

export function loadSession(): Session | null {
  const raw = localStorage.getItem(STORAGE_KEY) ?? sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as Session;
    if (!parsed?.token || !parsed?.user?.id) return null;
    if (parsed.expiresAt && Date.parse(parsed.expiresAt) < Date.now()) {
      clearSession();
      return null;
    }
    return parsed;
  } catch {
    clearSession();
    return null;
  }
}

/**
 * Grava a sessao. Sem `remember` (atualizacao de perfil, revalidacao), mantem
 * no storage onde ela ja estava.
 */
export function saveSession(session: Session, remember?: boolean): void {
  const persistent = remember ?? sessionStorage.getItem(STORAGE_KEY) === null;
  clearSession();
  (persistent ? localStorage : sessionStorage).setItem(STORAGE_KEY, JSON.stringify(session));
}

export function clearSession(): void {
  for (const storage of storages()) storage.removeItem(STORAGE_KEY);
}
